import React from "react";
import Grid from "@material-ui/core/Grid";
import AgeSlider from "./AgeSlider";

import styles from "./question.module.scss";

class ThirdQuestion extends React.Component {
  render() {
    return (
      <Grid container>
        <Grid item xs={12}>
          <h3 className={styles.title}>Выберите возраст</h3>
        </Grid>
        <Grid item xs={12} className={styles.content}>
          <AgeSlider />
        </Grid>
      </Grid>
    );
  }
}

export default ThirdQuestion;
